import { useMutation, useQuery } from "@apollo/client";
import {
  GetAllOrganizationTeamsQueryQuery,
  GetAllOrganizationTeamsQueryQueryVariables,
  UpdateMemberMutationMutation,
  UpdateMemberMutationMutationVariables,
} from "types/graphql-schema";

import getAllOrganizationTeamsQuery from "@apps/artifact/graphql/get-all-organization-teams-query";
import TeamPicker from "@apps/reporting/components/team-picker";
import { ButtonSize } from "@components/button/button-constants";
import { assertEdgesNonNull } from "@helpers/helpers";

import updateMemberMutation from "../graphql/update-member-mutation";

// The departments this person leads, whatever their role: their career tracks, and the
// competencies that reach only them, are the lead's to edit. Each change
// saves straight away.
const MemberLedDepartments = ({
  organizationId,
  userId,
  ledTeamIds,
}: {
  organizationId: number;
  userId: number;
  ledTeamIds: readonly number[];
}) => {
  const { data } = useQuery<
    GetAllOrganizationTeamsQueryQuery,
    GetAllOrganizationTeamsQueryQueryVariables
  >(getAllOrganizationTeamsQuery, { variables: { organizationId } });
  const [updateMember, { loading: isSaving }] = useMutation<
    UpdateMemberMutationMutation,
    UpdateMemberMutationMutationVariables
  >(updateMemberMutation);

  const departments = data?.organization
    ? assertEdgesNonNull(data.organization.teams)
    : [];
  const ledDepartments = departments.filter(({ id }) =>
    ledTeamIds.includes(id),
  );
  const save = (teamIds: number[]) =>
    updateMember({
      variables: { organizationId, userId, ledTeamIds: teamIds },
    });

  return (
    <TeamPicker
      size={ButtonSize.medium}
      canChange={!isSaving}
      teams={ledDepartments}
      // The member's organization, which may not be the one selected.
      organizationId={organizationId}
      onAddTeam={(team) => save([...ledTeamIds, team.id])}
      onRemoveTeam={(team) => save(ledTeamIds.filter((id) => id !== team.id))}
    />
  );
};

export default MemberLedDepartments;
